<template>
    <component :is="layout">
        <transition-page>
            <router-view :key="$route.fullPath" />
        </transition-page>
    </component>
</template>

<script>
import TransitionPage from '@/weact/components/TransitionPage';

const default_layout = 'default';

export default {
    components: {
        TransitionPage
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + "-layout";
        }
    }
};
</script>